var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFF6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37434 9C9.37434 7.55025 10.5496 6.375 11.9993 6.375C13.4491 6.375 14.6243 7.55025 14.6243 9C14.6243 10.4497 13.4491 11.625 11.9993 11.625C10.5496 11.625 9.37434 10.4497 9.37434 9Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18757 17.2281C7.23268 14.6091 9.36966 12.5 11.9993 12.5C14.6291 12.5 16.7661 14.6092 16.8111 17.2283C16.8141 17.402 16.714 17.561 16.5561 17.6335C15.1684 18.2702 13.6248 18.625 11.9995 18.625C10.3741 18.625 8.83034 18.2701 7.44253 17.6333C7.28464 17.5608 7.18457 17.4018 7.18757 17.2281Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.250c89223930dd9501a67943391cafa8.svg";
export { ForwardRef as ReactComponent };